import { permissionTree, RESOURCE_PROYECTOS_TI } from '@/auth/permissions/modules/proyectosTi'
import { ROUTE_MANTENIMIENTO_CARGO } from '@/router/routes/proyectos-ti/names'
import { defineMenu } from '@/utils/menu'

export default defineMenu([
    {
        title: 'proyectosTi.subopciones.crear_cargo',
        resource: RESOURCE_PROYECTOS_TI,
        action: permissionTree.mantenimiento.cargos,
        route: ROUTE_MANTENIMIENTO_CARGO,
    },
])
